<template>
  <px-autocomplete-user-comprador-multiple
    dense
    outlined
    autocomplete="off"
    class="required rounded-tag-small"
    label="Usuários"
    :roles="[]"
    v-bind="$attrs"
    v-model="localValue"
    @blur="onBlur"/>
</template>

<script>
export default {
  props: {
    value: Array,
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    onBlur(event) {
      this.$emit('blur', event);
    },
  },
};
</script>
